"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=VersionNumber.js.map